import { LimitFragment, Limit_Time_Period } from '@occc/graphql';

import { InfoField } from '@occc-app/design-system';
import {
  arrangeNodeGroups,
  renderNodeGroups,
} from '@occc-app/routes/CampaignComponents/component-details/sections/utils';

import { LimitCategory, limitConfigMap } from './limits-section.constants';

import { SectionCard } from '../../components';
import { BLOCKS_IN_ROW } from '../constants';

type LimitsSectionProps = {
  limits: LimitFragment[];
};

type LimitItem = {
  label: string;
  value: string;
  category: LimitCategory;
};

const hasTimePeriod = (
  limit: LimitFragment,
): limit is LimitFragment & { timePeriod: Limit_Time_Period } => {
  return 'timePeriod' in limit;
};

const getLimitItems = (limits: LimitFragment[]): LimitItem[] => {
  return limits
    .map((limit) => {
      const config = limitConfigMap[limit.__typename];
      if (!config) return null;

      const value = config.format({
        limit: limit.limit,
        timePeriod: hasTimePeriod(limit) ? limit.timePeriod : undefined,
      });

      return { label: config.label, value, category: config.category };
    })
    .filter(Boolean) as LimitItem[];
};

export const LimitsSection = ({ limits }: LimitsSectionProps) => {
  if (!limits || limits.length === 0) {
    return null;
  }

  const limitItems = getLimitItems(limits);

  if (limitItems.length === 0) {
    return null;
  }

  const fulfillmentLimits = limitItems.filter((item) => item.category === 'fulfillment');
  const progressLimits = limitItems.filter((item) => item.category === 'progress');
  const transactionLimits = limitItems.filter((item) => item.category === 'transaction');

  const blockGroups = arrangeNodeGroups(
    [
      fulfillmentLimits.map((item) => <InfoField label={item.label} value={item.value} />),
      progressLimits.map((item) => <InfoField label={item.label} value={item.value} />),
      transactionLimits.map((item) => <InfoField label={item.label} value={item.value} />),
    ],
    BLOCKS_IN_ROW,
  );

  return blockGroups.length ? (
    <SectionCard title='Limits'>{renderNodeGroups(blockGroups, BLOCKS_IN_ROW)}</SectionCard>
  ) : null;
};
